/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorModule } from './errorModule';


export interface ErrorDefinitions { 
    appDefaultErrorMessage?: string;
    errorCodePrefix?: string;
    errorConstantPrefix?: string;
    errorModules?: Array<ErrorModule>;
    moduleDefaultErrorMessageKeySuffix?: string;
}

